import axios from 'axios';
import { getCookie, setCookie, removeCookie } from '@util/cookie';
import { dealPromise } from "./dealPromise";
import { grayList } from "../../constants/gray";

const getGrayCookiesObj = (grayList) => {
  let cookies = {};
  grayList.forEach(item => {
    if (typeof item === 'string') {
      cookies[item] = {
        cookieName: item,
        cookieValue: 'Y',
        shouldReload: true
      };
    } else {
      cookies[item.testKey] = {
        cookieName: item.cookieName || item.testKey,
        cookieValue: item.cookieValue || 'Y',
        shouldReload: item.shouldReload === undefined || item.shouldReload
      };
    }
  });
  return cookies;
};
let grayCookies = getGrayCookiesObj(grayList);

export const setGrayCookies = function (requestid) {
  if (grayCookies.length === 0 || !requestid) {
    return;
  }
  const testKeys = Object.keys(grayCookies).join(",");
  getGrey(requestid, testKeys).then(res => {
    if (res && res.code === 200) {
      let shouldReload = false;
      delete res.code;
      delete res.msg;
      Object.keys(res).forEach(item => {
        if (grayCookies[item]) {
          shouldReload = verifyCookie(grayCookies[item], res[item]) || shouldReload;
        }
      });
      if (shouldReload === true) {
        window.location.reload();
      }
    }
  });
};
function getGrey (agencyid, testKeys) {
  return axios.get(`/erpabtest-api-v2/batch/getTreatmentFe?agencyid=${agencyid}&testKeys=${testKeys}`);
}
function verifyCookie (grayItem, res) {
  if (!grayItem.cookieName) {
    return false;
  }
  let shouldReload = false;
  if (res.strategy) {
    if (getCookie(grayItem.cookieName) !== grayItem.cookieValue) {
      setCookie(grayItem.cookieName, grayItem.cookieValue);
      shouldReload = true;
    }
  } else {
    if (getCookie(grayItem.cookieName)) {
      removeCookie(grayItem.cookieName);
      shouldReload = true;
    }
  }
  return shouldReload && grayItem.shouldReload;
}



// WEBPACK FOOTER //
// ./src/components/util/setGrayCookies.js